import useSWR from "swr"
import { fileManagementApi } from "features/data-management/files/fileManagementApi"

export const useCommentImageUrls = (keys: string[]) => {
    const { data } = useSWR(keys.length > 0 ? ["comment-image-urls", ...keys] : null, () =>
        Promise.all(keys.map((key) => fileManagementApi.getDownloadUrl(key)))
    )

    return keys.map((key, index) => ({ id: key, url: data?.[index] ?? "" }))
}
